import React, { useEffect } from "react";
import Confetti from "react-confetti";
import CustomModal from "common/CustomModal";
import { useModalGac } from "hooks/useModalGac";
import { ReactComponent as CloseIcon } from "assets/icons/components/search/close.svg";
import "styles/pop-up/index.css";

const MainPopUp = () => {
  const [isOpenModal, openModal, closeModal] = useModalGac(false);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    // Obtener el conteo de veces que se ha mostrado el popup
    const popupShowCount = localStorage.getItem("popupShowCount");
    const parsedCount = popupShowCount ? parseInt(popupShowCount, 10) : 0;

    if (parsedCount < 1) {
      openModal();
      // Incrementar el contador en localStorage
      localStorage.setItem("popupShowCount", (parsedCount + 1).toString());
    }
  }, []);

  const handleClose = () => {
    closeModal();
  };

  return (
    <>
      <CustomModal isOpen={isOpenModal} closeModal={handleClose}>
        <button className="btn-close-modal" onClick={handleClose}>
          <CloseIcon className="icon-close" />
        </button>
        <Confetti
          colors={["#003893", "#ffcf04", "#ed0a26"]}
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={isMobile ? 100 : 330}
          gravity={0.2}
          wind={0.1}
          initialVelocityX={{ min: -20, max: 20 }}
          initialVelocityY={{ min: -20, max: 20 }}
        />

        <img
          className="img-fluid"
          src="https://53fde1b606cff91e7a3b23ff9c242152.grupoalianzacolombia.com/uploads/gif_navidad.gif"
          alt="medios de pago grupo alianza colombia"
        />
      </CustomModal>
    </>
  );
};

export default MainPopUp;
